module.exports = __webpack_public_path__ + "img/spe.db5399d.png";